export default __webpack_public_path__ + "static/media/InfinitiFavicon.87ca388c.svg";